import type { MasonryEngineActionHandler } from "@leagueplatform/masonry-engine";
import { openUploadPhysicianFormModal } from "utils/upload-physician-form/modal-store";

export const QuestOpenUploadFormModalActionHandler: MasonryEngineActionHandler<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any
> = () => {
  openUploadPhysicianFormModal();
};
